import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { CreateCaseDialog } from "components/AlertsManagement/Case/form/CreateCaseDialog";
import { AddToExistingCaseDialog } from "components/AlertsManagement/Case/form/AddToExistingCaseDialog";
import { SplitButton } from "components/SplitButton";
import { styled } from "@mui/material/styles";

export function AlertInfoActions({
  alert,
  onCreateCaseComplete,
  onClickDismissAlert
}) {
  const [openCaseDialog, setOpenCaseDialog] = useState(false);
  const [openExistingCaseDialog, setOpenExistingCaseDialog] = useState(false);

  const splitButtonOptions = [
    {
      id: "create-new-case",
      title: "Create new case",
      onClick: () => {
        setOpenCaseDialog(true);
      }
    },
    {
      id: "add-to-existing-case",
      title: "Add to existing case",
      onClick: () => {
        setOpenExistingCaseDialog(true);
      }
    }
  ];

  return (
    <>
      <ButtonWrapper>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => onClickDismissAlert([alert])}
        >
          Dismiss
        </Button>
        <SplitButton
          variant="contained"
          color="primary"
          options={splitButtonOptions}
        />
      </ButtonWrapper>
      {openCaseDialog && (
        <CreateCaseDialog
          alert={alert}
          open={openCaseDialog}
          onClose={() => {
            setOpenCaseDialog(false);
          }}
          onCaseCreateSuccess={onCreateCaseComplete}
        />
      )}

      {openExistingCaseDialog && (
        <AddToExistingCaseDialog
          alert={alert}
          open={openExistingCaseDialog}
          onClose={() => {
            setOpenExistingCaseDialog(false);
          }}
          onCaseCreateSuccess={onCreateCaseComplete}
        />
      )}
    </>
  );
}

AlertInfoActions.propTypes = {
  alert: PropTypes.object,
  onCreateCaseComplete: PropTypes.func,
  onClickDismissAlert: PropTypes.func
};

const ButtonWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${props => props.theme.spacing(1)};
  flex-grow: 1;
  white-space: nowrap;
`;
